import { render, staticRenderFns } from "./ThemeableFrontendSkeleton.vue?vue&type=template&id=0e30282c"
import script from "./ThemeableFrontendSkeleton.vue?vue&type=script&lang=js"
export * from "./ThemeableFrontendSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports